import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useFormContext } from '../state';
import { SearchBusiness } from './input';
import { Form, Prompt, Title } from './templates';

export function StepOneSearch() {
  const { t } = useTranslation('stepOneSearch');
  const { onNext } = useFormContext();

  const closeSearch = useCallback(
    (addInfoMode?: 'manual' | 'automatic') => {
      onNext?.({ addInfoMode });
    },
    [onNext],
  );

  return (
    <Form>
      <Title text={t('title')} showStepCounter />
      <Prompt text={t('prompt1')} />
      <SearchBusiness closeSearch={closeSearch} />
    </Form>
  );
}
